/**
 * Mode-aware wrapper for the pairs route.
 * Dispatches to in-person or remote page based on {@link useMode}.
 */

import { useMode } from '@/contexts/ModeContext';
import { PairsManagementPage as PairsInPersonManagementPage } from '@/components/pages/management-pages/inperson/PairsManagementPage';
import { PairsManagementPage as PairsRemoteManagementPage } from '@/components/pages/management-pages/remote/PairsManagementPage';

/** Mode-aware wrapper that mounts in-person or remote pairs. */
export function PairsRouteDispatcher() {
  const { mode } = useMode();

  if (mode === 'remote') {
    return <PairsRemoteManagementPage />;
  }

  return <PairsInPersonManagementPage />;
}
